import { gql } from '@graphql/__generated__';

export const GET_AGENCY = gql(/* GraphQL */ `
  query ProfileLayoutAgency($userId: uuid!, $tenantId: uuid!) {
    teams(
      where: {
        show_in_agency_pages: { _eq: true }
        tenant_id: { _eq: $tenantId }
        teams_users: { user_id: { _eq: $userId }, deactivated: { _eq: false } }
      }
      limit: 1
    ) {
      id
      name
      agency_slug
      is_unclaimed
      logo {
        url
      }
      teams_users(where: { deactivated: { _eq: false } }) {
        is_leader
        user {
          id
          full_name
          agent_slug
          show_in_agency_pages
          user_images(limit: 1) {
            image {
              url
            }
          }
        }
      }
    }
  }
`);

export const TAKEDOWN_AGENT = gql(/* GraphQL */ `
  mutation ProfileTakedownAgent {
    takedown_agent {
      success
    }
  }
`);

export const SEND_SLACK_NOTIFICATION = gql(/* GraphQL */ `
  mutation ProfilePageSlackNotification($channel: String!, $text: String!) {
    send_slack_notification(channel: $channel, text: $text) {
      success
      error
    }
  }
`);

export const TAKEDOWN_AGENCY = gql(/* GraphQL */ `
  mutation ProfileTakedownAgency($teamId: uuid!) {
    takedown_agency(team_id: $teamId) {
      success
    }
  }
`);
